import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { updateState } from "../handlers/updates";
import Alpine from "alpinejs";

export default class ProgressBar extends AlpineComponent {
  constructor(public active: boolean = false) {
    super();
  }

  init() {
    Alpine.effect(() => {
      this.active = updateState.phase === "downloading" || updateState.phase === "uploading";
    });
  }
}
